<template>
  <div id="ResetPasswordV2">
    <div>
      <div class="form min-height">
        <div class="form-content">
          <h2 class="form-title">
            {{ componentText.title }}
          </h2>
          <b-form-group
            v-if="BOAClients && BOAClients.length"
            id="clientList"
            :label="componentText.BOAClients"
            label-for="clientSelect"
            >
            <div class="client-select">
                <b-form-select
                  id="clientSelect"
                  v-model="selectedBOAClientId"
                  class="form-control"
                  required
                >
                  <option :value="null" disabled>Please Select...</option>
                  <option
                    v-for="client in BOAClients"
                    :value="client.client_id"
                    >{{ client.organisation_name }}</option
                  >
               </b-form-select>
                <i class="fa fa-chevron-down" aria-hidden="true"></i>
            </div>
          </b-form-group>
          <b-form-group
            id="input-group"
            :label="componentText.password"
            label-for="newPassword"
          >
            <div class="password-wrap">
              <b-form-input
                :type="passwordFieldType"
                v-model="$v.newPassword.$model"
                id="newPassword"
                required
              ></b-form-input>
              <div class="eye" @click="switchVisibility">
                <font-awesome-icon
                  v-if="passwordFieldType === 'password'"
                  icon="eye"
                ></font-awesome-icon>
                <font-awesome-icon v-else icon="eye-slash"></font-awesome-icon>
              </div>
            </div>
            <b-form-invalid-feedback id="password-error">
              {{ componentText.passInvalid }}
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group v-if="$v.newPassword.$model" class="col-md-12 validationBox">
            <span :class="[tenChars?'passed':'failed']"><i class="fa-light fa-xmark" v-if="!tenChars"></i><i class="fa-light fa-check" v-else></i> At least 10 characters</span><br>
            <span :class="[upperCase?'passed':'failed']"><i class="fa-light fa-xmark" v-if="!upperCase"></i><i class="fa-light fa-check" v-else></i> At least 1 uppercase letter</span><br>
            <span :class="[lowerCase?'passed':'failed']"><i class="fa-light fa-xmark" v-if="!lowerCase"></i><i class="fa-light fa-check" v-else></i> At least 1 lowercase letter</span><br>
            <span :class="[contNumber?'passed':'failed']"><i class="fa-light fa-xmark" v-if="!contNumber"></i><i class="fa-light fa-check" v-else></i> At least 1 number</span><br>
            <span :class="[specChar?'passed':'failed']"><i class="fa-light fa-xmark" v-if="!specChar"></i><i class="fa-light fa-check" v-else></i> At least 1 special character</span>
          </b-form-group>
          <b-form-group
            id="input-group-repeat"
            :label="componentText.repeat"
            label-for="repeatPassword"
          >
            <div class="password-wrap">
              <b-form-input
                :type="repeatPasswordFieldType"
                v-model="$v.repeatPassword.$model"
                id="repeatPassword"
                required
                @keyup.enter.native="submitForm"
              ></b-form-input>
              <div class="eye" @click="switchVisibility('repeat')">
                <font-awesome-icon
                  v-if="repeatPasswordFieldType === 'password'"
                  icon="eye"
                ></font-awesome-icon>
                <font-awesome-icon v-else icon="eye-slash"></font-awesome-icon>
              </div>
            </div>
          </b-form-group>
          <b-form-group v-if="$v.repeatPassword.$model" class="col-md-12 validationBox">
            <span :class="[$v.repeatPassword.sameAsPassword?'passed':'failed']"><i class="fa-light fa-xmark" v-if="!$v.repeatPassword.sameAsPassword"></i><i class="fa-light fa-check" v-else></i>{{$v.repeatPassword.sameAsPassword ? " Passwords match" : " Passwords do not match"}}</span>
          </b-form-group>
          <div
            col-sm-12
            class="submit-form d-flex align-items-center justify-content-center"
          >
            <b-button
                :disabled="buttonDisabled"
                class="cta-button py-3 mt-5"
                type="button"
                @click.stop.prevent="submitForm"
                block
              ><span></span>
              <span>{{ componentText.buttonText }}</span>
              <i class="fa fa-arrow-right" aria-hidden="true"></i>
              </b-button
            >
          </div>
        </div>
      </div>
    </div>
    <div class="back" @click="$router.push('/')">Back to Login</div>
    <popup
      v-if="showPopup"
      :content="popupContent"
      class="popupV2"
      v-on:close="hidePopup(popupContent)"
    ></popup>
  </div>
</template>

<script>
import axios from "axios";
import config from "../../config/constants";
import popup from "../Popup.vue";
import EventBus from "@/helpers/eventbus";
import { validationMixin } from "vuelidate";
import { required, minLength, sameAs } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
export default {
  components: {
    popup,
  },
  name: "ResetPasswordV2",
  mixins: [validationMixin],
  props: ["BOAClients", "authKey"],
  data() {
    return {
      newPassword: "",
      repeatPassword: "",
      showPopup: false,
      popupContent: {},
      passwordFieldType: "password",
      repeatPasswordFieldType: "password",
      tenChars: false,
      upperCase: false,
      lowerCase: false,
      contNumber: false,
      specChar: false,
      pw_flag: false,
      selectedBOAClientId: null
    };
  },
  validations: {
    newPassword: {
      required,
      minLength: function(value) {
        this.tenChars = value.length > 9;
        return value.length > 9;
      },
      containsUppercase: function(value) {
        this.upperCase = /[A-Z]/.test(value);
        return /[A-Z]/.test(value);
      },
      containsLowercase: function(value) {
        this.lowerCase = /[a-z]/.test(value);
        return /[a-z]/.test(value);
      },
      containsNumber: function(value) {
        this.contNumber = /[0-9]/.test(value);
        return /[0-9]/.test(value);
      },
      containsSpecial: function(value) {
        this.specChar = /[^a-zA-Z0-9\-\/]/.test(value);
        return /[^a-zA-Z0-9\-\/]/.test(value);
      }
    },
    repeatPassword: {
      sameAsPassword: sameAs("newPassword"),
    },
  },
  methods: {
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    submitForm() {
      this.$v.$touch();
      if (this.$v.$anyError) {
        return;
      } else {
        this.sendReset();
      }
    },
    async sendReset() {
      let params = this.$route.query;

      const payload = {
        auth_key: params.auth_key,
        password: this.newPassword,
        password_repeat: this.repeatPassword,
        lang: this.$store.state.lang,
      };
      // email is optional: present only on flag-off links (?id=). Forward it
      // when the URL carried it; omit it entirely otherwise (flag-on links).
      if (params.id) {
        payload.email = params.id;
      }
      if (this.selectedBOAClientId) {
        payload.client_id = this.selectedBOAClientId
      }
      const options = {
        headers: {
          "Content-type": "application/x-www-form-urlencoded; charset=utf-8",
        },
      };
      let res = await axios.post(
        config.api_env + "/application/api-hc/reset-password",
        payload,
        options
      );
      if (res.data.success) {
        this.popupContent = {
          success: true,
          header: this.componentText.successTitle,
          message: this.componentText.success,
        };

      } else {
        this.popupContent = {
          success: false,
          header: this.componentText.error,
          message: this.passwordErrorText + '<br><br>Current Error:<br>' + res.data.err,
        };
      }
      this.showPopup = true;
    },
    hidePopup(popupContent){
      this.showPopup = false;
      if (popupContent.success) {
        EventBus.$emit("reset-pass");
      }
    },
    switchVisibility(type) {
      if (type === 'repeat') {
        this.repeatPasswordFieldType =
          this.repeatPasswordFieldType === "password" ? "text" : "password";
      } else {
        this.passwordFieldType =
          this.passwordFieldType === "password" ? "text" : "password";
      }
    },
  },
  computed: {
    ...mapGetters(["hardcoded", "skin"]),
    buttonDisabled() {
      this.$v.$touch();
      if (this.$v.$anyError || (this.BOAClients && this.BOAClients.length && !this.selectedBOAClientId)) {
        return true;
      }
      return false;
    },
    getLogo() {
      if (this.hardcoded && this.hardcoded.logo) {
        return this.hardcoded.logo;
      } else return this.$store.getters.client.client_logo;
    },
    componentText() {
      return this.getText.notLoggedIn.resetPassword;
    },
    passwordErrorText(){
      return this.getText.notLoggedIn.signUp.errorMessage
    }
  },
};
</script>
<style lang="less">
#ResetPasswordV2 {
  width: 100%;
  padding: 30px 60px;
  height: 100%;
  div, img {
    width: 100%;
  }
  .form-logo {
    width: 50%;
    margin: auto;
    display: block;
    margin-bottom: 30px;
  }
  .form-title {
    color: #122130;
    font-family: "Raptor V3 Black";
    font-size: 3.6rem;
  }
  .eye {
    cursor: pointer;
    width: 30px;
    position: absolute;
    bottom: 12px;
    right: 4px;
    font-size: 20px;
  }
  .form-group {
    position: relative;
  }
  label {
    font-size: 1.5rem;
  }
  input, .form-control {
    all: unset;
    height: 25px;
    width: 100%;
    position: relative;
    margin: 0;
    font-family: 'DMSans', sans-serif;
    font-size: 1.4rem;
    background-color: transparent !important;
    border-bottom: #DCDBDD 1px solid;
    padding: 14px;
    color: #122130;
    border: #000 2px solid;
    border-radius: 5px;
  }
  .cta-button {
    width: 100%;
    max-width: 280px;
    border-radius: 10px;
    padding: 12px !important;
    font-family: "Raptor V3 Black";
    font-size: 1.6rem;
    background: #122130 !important;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: auto !important;
    min-width: 280px;
    letter-spacing: normal;
      .fa-arrow-right {
        background-color: #fff;
        color: #122130;
        border-radius: 5px;
        padding: 10px;
      }
      &.disabled {
        background: grey !important;
      }
  }
  .client-select {
    position: relative;
    font-size: 2rem;

    .fa-chevron-down {
      color: #122130;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 15px;
    }

    .custom-select {
      cursor: pointer !important;
    }
  }
  .back {
    color: #122130;
    margin-top: 40px;
    text-align: center;
    font-size: 1.6rem;
    cursor: pointer;
    text-decoration: underline;
    &:hover {
      text-decoration: none;
    }
  }
  .pop-up-content {
    background-color: #4b4949;
    button:hover {
      background: linear-gradient(90deg, #ED3A75 0%, #6A356A 100%);
    }
    .close-popup {
      padding: 5px !important;
    }
  }
}
</style>
